<div class="modal-overlay" (click)="$event.stopPropagation()">
  <div class="modal-content">

    <!-- Header -->
    <div class="modal-header">
      <div class="icon-container">
        <mat-icon class="icon-large">fingerprint</mat-icon>
      </div>
      <h2>Activa acceso rápido y seguro</h2>
      <p class="subtitle">Usa {{ biometricMethodName }} para validar tu identidad en segundos</p>
    </div>

    <!-- Body -->
    <div class="modal-body">

      <!-- Beneficios -->
      <div class="benefits">
        <div class="benefit">
          <mat-icon>speed</mat-icon>
          <div class="benefit-text">
            <strong>Acceso en 1 segundo</strong>
            <span>Sin esperar códigos por email</span>
          </div>
        </div>

        <div class="benefit">
          <mat-icon>security</mat-icon>
          <div class="benefit-text">
            <strong>Más seguro</strong>
            <span>Protección biométrica avanzada</span>
          </div>
        </div>

        <div class="benefit">
          <mat-icon>devices</mat-icon>
          <div class="benefit-text">
            <strong>Multi-dispositivo</strong>
            <span>Registra varios dispositivos</span>
          </div>
        </div>
      </div>

      <!-- Error -->
      @if (registrationError) {
        <div class="alert-error">
          <mat-icon>error_outline</mat-icon>
          <span>{{ registrationError }}</span>
        </div>
      }

    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button
        class="btn-primary"
        (click)="activatePasskey()"
        [disabled]="isRegistering">
        <mat-icon>fingerprint</mat-icon>
        @if (!isRegistering) {
          <span>Activar Passkey</span>
        }
        @if (isRegistering) {
          <span>Activando...</span>
        }
      </button>

      <button
        class="btn-secondary"
        (click)="remindMeLater()"
        [disabled]="isRegistering">
        Recordarme después
      </button>
    </div>

  </div>
</div>
